
<div class="confirmation-dialog-container" >
    <div (click)= "closeImg()"  class="dialog-title" ><img class="close-img" src="assets/icons/cross-small.png" alt="" ></div>
    <mat-dialog-content *ngIf="message">
   {{message}}
    </mat-dialog-content>
   
  
    <mat-dialog-actions align="center">
     
      <button
        mat-raised-button
        color="primary"
        class="mat-button-medium"
        (click)= "closeImg('swap')"
        
        
      >
        SWAP
      </button>
     
      <button
        mat-raised-button
        color="primary"
        class="mat-button-medium"
        (click)= "closeImg('ok')"
      
       
      >
        OK
      </button>
    </mat-dialog-actions>
  </div>
  <!-- [mat-dialog-close]="true" -->

